import baseAPI from './baseAPI';

export const getJobs = async (token) => {
  const resp = await baseAPI.get('/jobs.json');
  if (!resp.ok) {
    throw new Error('Failed to fetch jobs');
  }
  return await resp.json();
};
